export const settingRoute = {
  SETTING: '/setting',
  SETTING_BASIC: '/setting/basic',
  SETTING_CONSTULTANT: '/setting/consultant',
  SETTING_COMMISSION: '/setting/commission'
};
